import { ScoopButton, ScoopDialog, ScoopSelector, ScoopTable } from '../../../../ui'
import { TimeRangeControl } from '../../../../Insights/TimeRangeControl.jsx'
import { useState, useMemo, useCallback } from 'react'
import { AIFilter } from '../AIFilter/AIFilter'
import styles from './FilterAndTimeRange.module.scss'
import { useModal, MODALS } from '../../../../modals'

export const FilterAndTimeRange = ({
    server,
    title,
    pickFiltersDialogOpen,
    setPickFiltersDialogOpen,
    setSelectedFilters,
    selectedInbox,
    dialogSelectedFilters,
    setDialogSelectedFilters,
    filterDate,
    setFilterDate,
    config,
    setConfig,
    filterList,
    existingFilter,
}) => {
    const [aiDialogOpen, setAIDialogOpen] = useState(false)
    const timeRangeModal = useModal(MODALS.COMMON.TIME_RANGE)

    const columnDefs = useMemo(
        () => [
            {
                field: 'value',
                header: 'Saved Filter Name',
                flex: 1,
                sortable: false,
                checkboxSelection: true,
                headerCheckboxSelection: true,
            },
        ],
        []
    )

    const handleSelectionChange = useCallback(
        (selectedRows) => {
            const selectedIds = selectedRows.map((row) => row.id)
            setDialogSelectedFilters(selectedIds)
        },
        [setDialogSelectedFilters]
    )

    return (
        <ScoopDialog
            maxWidth="lg"
            open={pickFiltersDialogOpen}
            title={title}
            onClose={() => {
                setPickFiltersDialogOpen(false)
            }}
            actions={
                <>
                    <ScoopButton
                        variant="text"
                        size="sm"
                        onClick={() => {
                            setPickFiltersDialogOpen(false)
                        }}
                    >
                        Cancel
                    </ScoopButton>
                    <ScoopButton
                        variant="default"
                        size="sm"
                        onClick={() => {
                            setPickFiltersDialogOpen(false)
                            if (dialogSelectedFilters && dialogSelectedFilters.length > 0) {
                                setSelectedFilters(dialogSelectedFilters)
                            } else {
                                setSelectedFilters(null)
                            }
                        }}
                    >
                        Save
                    </ScoopButton>
                </>
            }
        >
            <div className={styles.dialogContent}>
                {existingFilter && (
                    <>
                        <div className={styles.label}>
                            The following filter is already applied - Use below to restrict further
                        </div>
                        <div className={styles.existingFilterInfo}>{existingFilter}</div>
                    </>
                )}
                {filterDate && (
                    <div className={styles.timeRangeSection}>
                        <div className={styles.label}>Restrict the time range of your dataset</div>
                        <div className={styles.timeRangeRow}>
                            {selectedInbox?.tables?.[0]?.dates?.length > 1 && (
                                <div className={styles.dateSelector}>
                                    <ScoopSelector
                                        label="Date to restrict"
                                        value={filterDate}
                                        onChange={(e) => setFilterDate(e.target.value)}
                                        options={
                                            selectedInbox?.tables?.[0]?.dates?.map((col) => ({
                                                label: col,
                                                value: col,
                                            })) || []
                                        }
                                        size="md"
                                    />
                                </div>
                            )}
                            <TimeRangeControl
                                config={config}
                                setConfig={setConfig}
                                onOpenTimeRange={() =>
                                    timeRangeModal.show({
                                        config,
                                        setConfig,
                                    })
                                }
                                controlHeight={40}
                            />
                        </div>
                    </div>
                )}
                <div>
                    <div className={styles.label}>
                        Select any saved filters you would like to use to restrict the data in your
                        dataset
                    </div>
                    <div className={styles.gridContainer}>
                        <ScoopTable
                            columns={columnDefs}
                            rows={filterList}
                            selection={{
                                mode: 'multiple',
                                onSelectionChange: handleSelectionChange,
                            }}
                            rowHeight={32}
                            headerHeight={40}
                            pagination={{
                                enabled: true,
                                pageSize: 20,
                            }}
                            emptyMessage="No saved filters available"
                        />
                    </div>
                    <div className={styles.createFilterRow}>
                        Don't see a filter you want?
                        <ScoopButton
                            className={styles.createFilterButton}
                            variant="default"
                            size="sm"
                            onClick={() => {
                                setAIDialogOpen(true)
                            }}
                        >
                            Create a new filter using AI
                        </ScoopButton>
                    </div>
                </div>
                <AIFilter
                    server={server}
                    AIFiltersDialogOpen={aiDialogOpen}
                    setAIFiltersDialogOpen={setAIDialogOpen}
                    selectedInbox={selectedInbox}
                    addFilter={(filterID) => {
                        setPickFiltersDialogOpen(false)
                        dialogSelectedFilters.push(filterID)
                        setSelectedFilters(dialogSelectedFilters)
                    }}
                    title="Add a Saved Filter Using AI"
                    dialogSelectedFilters={dialogSelectedFilters}
                    setDialogSelectedFilters={setDialogSelectedFilters}
                />
            </div>
        </ScoopDialog>
    )
}
